import { CountryCode } from '~/enums';
import { StepConfigItem } from '~/Interfaces';
import { CardMarket } from '~/types/types';
import { CardOfferView } from './CardOffer/CardOfferView';
import { CardPurpose } from './CardPurpose/CardPurpose';
import KYCQuestionnaire from './KYCQuestionnaire/KYCQuestionnaire';
import OwnershipV2 from './OwnershipV2/Ownership';
import OwnershipFooter from './OwnershipV2/OwnershipFooter';
import OwnershipHeader from './OwnershipV2/OwnershipHeader';
import { PasscodeStep } from './PasscodeStep/PasscodeStep';
import { PasscodeStepFooter } from './PasscodeStep/PasscodeStepFooter';
import Signers from './Signers/Signers';

const CardPurposeStep: StepConfigItem = {
  component: CardPurpose,
  header: {
    title: 'OnboardingCardOffer.Title',
    description: 'OnboardingCardOffer.CardPurposeDescription',
  },
  name: 'card_purpose_step',
};
const CardOfferStep: StepConfigItem = {
  component: CardOfferView,
  header: {
    title: 'OnboardingCardOffer.ConfirmOfferTitle',
    description: 'OnboardingCardOffer.ConfirmOfferDescription',
  },
  name: 'card_offer_step',
};
const KYCQuestionnaireStep: StepConfigItem = {
  header: {
    title: 'OnboardingOffer.KYCQuestionnaire',
    description: 'OnboardingOffer.KYCQuestionnaireDescription',
  },
  component: KYCQuestionnaire,
  name: 'kyc_questionnaire_step',
};

const SignersStep: StepConfigItem = {
  component: Signers,
  header: {
    title: 'Signers.Title',
    description: 'OnboardingCardOffer.SignersDescription',
  },
  name: 'additional_signers_and_guarantors_step',
};
const OwnershipStep: StepConfigItem = {
  component: OwnershipV2,
  customHeader: OwnershipHeader,
  customFooter: OwnershipFooter,
  name: 'ownership_step',
};

const CreatePasscodeStep: StepConfigItem = {
  component: PasscodeStep,
  customFooter: PasscodeStepFooter,
  name: 'create_passcode_step',
};

export const stepConfigPerMarket: Record<CardMarket, StepConfigItem[]> = {
  [CountryCode.SE]: [
    CardPurposeStep,
    OwnershipStep,
    SignersStep,
    KYCQuestionnaireStep,
    CardOfferStep,
  ],
  [CountryCode.FI]: [
    CardPurposeStep,
    OwnershipStep,
    SignersStep,
    KYCQuestionnaireStep,
    CardOfferStep,
  ],
  [CountryCode.NL]: [
    CardPurposeStep,
    OwnershipStep,
    SignersStep,
    KYCQuestionnaireStep,
    CardOfferStep,
  ],
  [CountryCode.DE]: [
    CreatePasscodeStep,
    CardPurposeStep,
    OwnershipStep,
    SignersStep,
    KYCQuestionnaireStep,
    CardOfferStep,
  ],
};
